import PreLoader from "./components/PreLoader";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Journey from "./components/Journey";
import About from "./components/About";
import Features from "./components/Features";
import Courses from "./components/Courses";
import Programs from "./components/Programs";
import Results from "./components/Results";
import Contact from "./components/Contact";
import Clients from "./components/Clients";
import Footer from "./components/Footer";
import ScrollTop from "./components/ScrollTop";

function MainHome() {
  return (
    <>
      <PreLoader/>
      <Header />
      <Hero />
      <Journey/>
      <About />
      <Features />
      <Courses/>
      <Programs />
      <Results/>
      <Contact />
      <Clients/>
      <Footer />
      <ScrollTop/>
    </>
  );
}

export default MainHome;